import { useState, useRef, useEffect, useContext, useCallback } from 'react';
import { 
  FaPlay, FaPause, FaStepForward, FaStepBackward, 
  FaVolumeUp, FaVolumeMute, FaRandom, FaRedoAlt 
} from 'react-icons/fa';
import { BsFillHeartFill, BsHeart, BsThreeDots } from 'react-icons/bs';

import { UserContext } from '../../Context/UserContext';
const Player = () => {

    const {currentTrack} = useContext(UserContext);
    const [isPlaying, setIsPlaying] = useState(false);
    const [progress, setProgress] = useState(0);
    const [volume, setVolume] = useState(80);
    const [isMuted, setIsMuted] = useState(false);
    const [isShuffleOn, setIsShuffleOn] = useState(false);
    const [isRepeatOn, setIsRepeatOn] = useState(false);
    const [isLiked, setIsLiked] = useState(false);
    const [showVolume, setShowVolume] = useState(false);
    const [isExpanded, setIsExpanded] = useState(false);
   
    const audioRef = useRef(null);
    const [duration, setDuration] = useState(0);

 
    const track = currentTrack;

  // Mock track data if none provided

  // Format time (seconds to MM:SS)
  useEffect(()=>{


    async function play(track){
       
        audioRef.current.audioSrc = track.audioSrc;
       //const d = await audioRef.current.duration;
        //console.log(d);
        //setDuration(d);
        await audioRef.current?.play().catch(e => console.error("Playback failed:", e));
        setIsPlaying(true);
    }
    if(track != "empty"){
      play(track);
    }
    
  },[track]);
  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins}:${secs < 10 ? '0' : ''}${secs}`;
  };
  useEffect(()=>{
    if(audioRef){
        ///setDuration(audioRef.current.duration);
    }
  },[audioRef]);
  // Handle play/pause
  const togglePlay = () => {
    if (isPlaying) {
      audioRef.current?.pause();
    } else {
      audioRef.current?.play().catch(e => console.error("Playback failed:", e));
    }
    setIsPlaying(!isPlaying);
  };

  // Handle progress update
  const handleTimeUpdate = () => {
    //console.log(duration)
    if(duration > 0){
        if (audioRef.current) {
          try{
            const currentTime = audioRef.current?.currentTime;
            const duration = audioRef.current?.duration || duration;
            setProgress((currentTime / duration) * 100);
          }catch(err){
            console.log(err);
          }
            
        }
    }else{
        return;
    }
    
  };

  // Handle seeking
  const handleSeek = useCallback((e) => {
    if(duration > 0){
        const seekPosition = e.target.value;
        const duration = audioRef.current?.duration || duration;
        if (audioRef.current) {
        audioRef.current.currentTime = (seekPosition / 100) * duration;
        }
        setProgress(seekPosition);
    }
    
  });

  // Handle volume change
  const handleVolumeChange = (e) => {
    const newVolume = e.target.value;
    setVolume(newVolume);
    if (audioRef.current) {
      audioRef.current.volume = newVolume / 100;
    }
    setIsMuted(newVolume === 0);
  };

  // Toggle mute
  const toggleMute = () => {
    if (audioRef.current) {
      if (isMuted) {
        audioRef.current.volume = volume / 100;
      } else {
        audioRef.current.volume = 0;
      }
      setIsMuted(!isMuted);
    }
  };

  // Toggle expanded view on mobile
  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  
  // Simulate audio element
  useEffect(() => {
    const audio = audioRef.current;
    if (audio) {
      audio.volume = volume / 100;
    }

    // Simulate progress update when playing
    let interval;
    if (isPlaying) {
      interval = setInterval(() => {
        if (audioRef.current) {
          handleTimeUpdate();
        }
      }, 1000);
    }

    return () => clearInterval(interval);
  }, [isPlaying]);

  if(currentTrack == "empty"){
    return <></>;
  }else{
    return (
      <>
        {/* Hidden audio element */}
        <audio 
          ref={audioRef} 
          onTimeUpdate={()=>{
             // handleTimeUpdate();
          
          }} 
          src={track.audioSrc}
          onEnded={() => setIsPlaying(false)}
          onLoadedMetadata={(e)=>{
             
             setDuration(e.currentTarget.duration);
          }}
        />
  
        {/* Mobile Player */}
        <div className={`fixed bottom-0 left-0 right-0 bg-gradient-to-r from-gray-900 to-gray-800 text-white border-t border-gray-700 transition-all duration-300
          ${isExpanded ? 'h-[180px]' : 'h-[72px]'}`}>
  
          {/* Collapsed View (Mobile) */}
          <div className={`container mx-auto ${isExpanded ? 'hidden' : 'block'}`}>
            <div className="flex items-center justify-between p-3">
              {/* Track Info */}
              <div 
                className="flex items-center flex-1 min-w-0"
                onClick={toggleExpanded}
              >
                <img 
                  src={track.coverUrl} 
                  alt={track.title} 
                  className="w-12 h-12 object-cover mr-3"
                />
                <div className="min-w-0">
                  <h4 className="text-sm font-medium truncate">{track.title}</h4>
                  <p className="text-xs text-gray-400 truncate">{track.artist}</p>
                </div>
              </div>
  
              {/* Mobile Controls */}
              <div className="flex items-center space-x-4 ml-3">
                <button 
                  onClick={() => setIsLiked(!isLiked)}
                  className="text-lg"
                >
                  {isLiked ? (
                    <BsFillHeartFill className="text-green-500" />
                  ) : (
                    <BsHeart className="text-gray-400" />
                  )}
                </button>
                
                <button 
                  onClick={togglePlay}
                  className="bg-white text-black rounded-full w-8 h-8 flex items-center justify-center"
                >
                  {isPlaying ? <FaPause /> : <FaPlay className="ml-0.5" />}
                </button>
              </div>
            </div>
          </div>
  
          {/* Expanded View (Mobile) */}
          <div className={`container mx-auto h-full flex flex-col ${isExpanded ? 'block' : 'hidden'}`}>
            {/* Close button */}
            <button 
              onClick={toggleExpanded}
              className="absolute top-2 right-4 text-gray-400 text-lg"
            >
              &times;
            </button>
  
            {/* Album Art */}
            <div className="flex justify-center mt-4 mb-3">
              <img 
                src={track.coverUrl} 
                alt={track.title} 
                className="w-40 h-40 object-cover rounded-md shadow-lg"
              />
            </div>
  
            {/* Track Info */}
            <div className="text-center px-4">
              <h3 className="text-lg font-bold truncate">{track.title}</h3>
              <p className="text-sm text-gray-400 truncate">{track.artist}</p>
            </div>
  
            {/* Progress Bar */}
            <div className="px-4 mt-2">
              <div className="w-full flex items-center space-x-2">
                <input
                  type="range"
                  min="0"
                  max="100"
                  value={progress}
                  onChange={handleSeek}
                  className="w-full h-1 bg-gray-600 rounded-lg appearance-none cursor-pointer [&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:h-3 [&::-webkit-slider-thumb]:w-3 [&::-webkit-slider-thumb]:rounded-full [&::-webkit-slider-thumb]:bg-white"
                />
              </div>
              <div className="flex justify-between text-xs text-gray-400 mt-1">
                <span>{formatTime((progress / 100) * track.duration)}</span>
                <span>{formatTime(track.duration)}</span>
              </div>
            </div>
  
            {/* Controls */}
            <div className="flex items-center justify-between px-6 mt-2">
              <button 
                onClick={() => setIsShuffleOn(!isShuffleOn)}
                className={`text-lg ${isShuffleOn ? 'text-green-500' : 'text-gray-400'}`}
              >
                <FaRandom />
              </button>
              
              <button className="text-gray-400 text-xl">
                <FaStepBackward />
              </button>
              
              <button 
                onClick={togglePlay}
                className="bg-white text-black rounded-full w-10 h-10 flex items-center justify-center"
              >
                {isPlaying ? <FaPause /> : <FaPlay className="ml-0.5" />}
              </button>
              
              <button className="text-gray-400 text-xl">
                <FaStepForward />
              </button>
              
              <button 
                onClick={() => setIsRepeatOn(!isRepeatOn)}
                className={`text-lg ${isRepeatOn ? 'text-green-500' : 'text-gray-400'}`}
              >
                <FaRedoAlt />
              </button>
            </div>
          </div>
        </div>
  
        {/* Desktop Player (hidden on mobile) */}
        <div className="hidden md:block fixed bottom-0 left-0 right-0 bg-gradient-to-r from-gray-900 to-gray-800 text-white p-4 border-t border-gray-700">
          <div className="container mx-auto flex items-center justify-between">
            {/* Track Info (Left) */}
            <div className="flex items-center w-1/4">
              <div className="relative group">
                <img 
                  src={track.coverUrl} 
                  alt={track.title} 
                  className="w-14 h-14 object-cover mr-3"
                />
                <button 
                  onClick={() => setIsLiked(!isLiked)}
                  className="absolute -bottom-1 -right-1 opacity-0 group-hover:opacity-100 transition-opacity"
                >
                  {isLiked ? (
                    <BsFillHeartFill className="text-green-500 text-xl" />
                  ) : (
                    <BsHeart className="text-white text-xl hover:text-green-500" />
                  )}
                </button>
              </div>
              <div>
                <h4 className="text-sm font-medium line-clamp-1 text-gray-50">{track.title}</h4>
                <p className="text-xs text-gray-400 line-clamp-1">{track.artist}</p>
              </div>
            </div>
  
            {/* Player Controls (Center) */}
            <div className="flex flex-col items-center w-2/4">
              <div className="flex items-center space-x-6 mb-2">
                <button 
                  onClick={() => setIsShuffleOn(!isShuffleOn)}
                  className={`text-lg ${isShuffleOn ? 'text-green-500' : 'text-gray-400 hover:text-white'}`}
                >
                  <FaRandom />
                </button>
                
                <button className="text-gray-400 hover:text-white text-xl">
                  <FaStepBackward />
                </button>
                
                <button 
                  onClick={togglePlay}
                  className="bg-white text-black rounded-full w-8 h-8 flex items-center justify-center hover:scale-105 transition-transform"
                >
                  {isPlaying ? <FaPause /> : <FaPlay className="ml-0.5" />}
                </button>
                
                <button className="text-gray-400 hover:text-white text-xl">
                  <FaStepForward />
                </button>
                
                <button 
                  onClick={() => setIsRepeatOn(!isRepeatOn)}
                  className={`text-lg ${isRepeatOn ? 'text-green-500' : 'text-gray-400 hover:text-white'}`}
                >
                  <FaRedoAlt />
                </button>
              </div>
  
              <div className="w-full flex items-center space-x-2">
                <span className="text-xs text-gray-400 w-10 text-right">
                  {formatTime((progress / 100) * duration)}
                </span>
                <input
                  type="range"
                  min="0"
                  max="100"
                  value={progress}
                  onChange={handleSeek}
                  className="w-full h-1 bg-gray-600 rounded-lg appearance-none cursor-pointer [&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:h-3 [&::-webkit-slider-thumb]:w-3 [&::-webkit-slider-thumb]:rounded-full [&::-webkit-slider-thumb]:bg-white"
                />
                <span className="text-xs text-gray-400 w-10">
                  {formatTime(duration)}
                </span>
              </div>
            </div>
  
            {/* Volume Controls (Right) */}
            <div className="flex items-center justify-end w-1/4 space-x-3">
              <button 
                onClick={toggleMute} 
                className="text-gray-400 hover:text-white"
              >
                {isMuted ? <FaVolumeMute /> : <FaVolumeUp />}
              </button>
              <input
                type="range"
                min="0"
                max="100"
                value={isMuted ? 0 : volume}
                onChange={handleVolumeChange}
                className="w-24 h-1 bg-gray-600 rounded-lg appearance-none cursor-pointer [&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:h-3 [&::-webkit-slider-thumb]:w-3 [&::-webkit-slider-thumb]:rounded-full [&::-webkit-slider-thumb]:bg-white"
              />
            </div>
          </div>
        </div>
      </>
    );
  } 
  
};

export default Player;